import type { FeatureFlag } from '@ps/web-core-enums';
import { canUseDOM, tryParse } from '@ps/web-core-utils';

import type { Model } from '../../types';

import effects from './effects';
import selectors from './selectors';

export type Feature = Partial<{ [key in FeatureFlag]: boolean }>;
export type FeatureState = Feature;

const overrides: FeatureState | false =
  canUseDOM && (tryParse(localStorage.getItem('starsweb-features')) as FeatureState);

const reducers = {
  'persist/REHYDRATE': (state: Feature) => ({ ...state, ...overrides }),
  update: (state: Feature, payload: Feature) => ({ ...state, ...payload, ...overrides })
};

const feature: Model<FeatureState, typeof reducers, void, typeof effects, typeof selectors> = {
  state: overrides || {},
  reducers,
  effects,
  selectors
};

export default feature;
